import PropTypes from "prop-types"
import React from "react"

import useIsTouchDevice from "src/hooks/use_is_touch_device"

import ModalBody from "./ModalBody"
import ModalDesktop from "./ModalDesktop"
import ModalFooter from "./ModalFooter"
import ModalHeader from "./ModalHeader"
import ModalMobile from "./ModalMobile"

const Modal = (props) => {
  const isTouchDevice = useIsTouchDevice()
  return isTouchDevice ? (
    <ModalMobile {...props} />
  ) : (
    <ModalDesktop {...props} />
  )
}

Modal.Footer = ModalFooter
Modal.Header = ModalHeader
Modal.Body = ModalBody

Modal.propTypes = {
  children: PropTypes.node.isRequired,
  onClose: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  afterLeave: PropTypes.func,
  size: PropTypes.oneOf([
    "small",
    "mediumFixed",
    "large",
    "extraLarge",
    "default",
    "mediumResponsive",
  ]),
  minSize: PropTypes.oneOf(["default", "medium"]),
  maxSize: PropTypes.oneOf(["default", "medium"]),
  initialFocusRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  stacked: PropTypes.bool,
}

export default Modal
